import { createSelector } from '@reduxjs/toolkit';
export var get = function get(state) {
  return state.assignmentTemplates;
};
export var loading = createSelector(get, function (state) {
  return state.loading;
});
export var error = createSelector(get, function (state) {
  return state.error;
});
export var meta = createSelector(get, function (state) {
  return state.meta;
});
export var getAssignmentTemplateById = function getAssignmentTemplateById(id) {
  return createSelector(get, function (state) {
    return state.byId[id];
  });
};
export var getAssignmentTemplates = createSelector(get, function (state) {
  return Object.values(state.byId).sort(function (a, b) {
    return a.created_at < b.created_at ? 1 : -1;
  });
});